import VenueContextSelect from "components/data/VenueSelect/VenueContextSelect";

const VenueSettings: React.FC = () => <VenueContextSelect />;

export default VenueSettings;
